import React, { Component } from "react";
import plant from "../../../../media/reduced-images/plant.jpg";
import Helmet from "react-helmet";
import Servcies from "../../ServicesPane/Services";

import styles from "./ManufacturingCapabilities.module.scss";

class ManufacturingCapabilities extends Component {
  render() {
    const headerImageProps = {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundImage: `url(${plant})`
    };

    return (
      <div id={styles.manufacturingContainer}>
        <Helmet>
          <title>Manufacturing Capabilities</title>
          <meta
            name="description"
            content="Learn about the contract manufacturing services we offer."
          />
        </Helmet>
        <div id={styles.headerImageContainer} style={headerImageProps}>
          <div id={styles.titleText}>Manufacturing Capabilities</div>
        </div>
        <div id={styles.overviewContainer}>
          <div id={styles.overview}>
            <div className={styles.header}>
              <span className={styles.headerText}>Overview</span>
            </div>
            <div className={styles.content}>
              As a contract manufacturer, we have a variety of pulverizing,
              screening, and blending equipment. We can create a production line
              to meet the exact requirements of your product. This minimizes
              handling, losses and contamination risks. Please note, we only
              process non-hazerdous materials.
            </div>
          </div>
          <div id={styles.capabilities}>
            <div className={styles.header}>
              <span className={styles.headerText}>Plant Capabilities</span>
            </div>
            <div className={styles.content}>
              No job is too small or too large for our facility to handle. We
              have lab equipment to produce small samples and pilot runs. We can
              process well over 500,000 lbs per month. We also have a separate
              sorting line to inspect and remove contaminants from larger raw
              materials.
            </div>
          </div>

          <div id={styles.moreInfo}>
            Click on the icons below for more information:
          </div>
        </div>
        <Servcies />
      </div>
    );
  }
}

export default ManufacturingCapabilities;
